import React from "react";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";

import CheckboxCardQuestion from "../../../../question/ChecboxCardQuestion";
import {getRiskProfilingAnswers, skipSrriValidation} from "../../../../../../../utils";
import {getSubSystemConfigItem} from "../../../../../../../../../utils/utils";
import {SERVICE_CONCEPTS} from "../../../../../../../../Trades/constants";
import PortfolioBuilderInfoText
  from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/PortfolioBuilder/components/PortfolioBuilderInfoText";


const DepositsStepV2 = props => {
  const {
    onAnswerChange,
    dataService,
    questions: [{
      question: [
        fundsCheckbox,
        piCheckbox,
        individualAssetManagementCheckbox,
        mpCheckbox,
        portfolioBuilderCheckbox,
        vlPlanCheckbox,
        einzeltitelCheckbox
      ]
    }],
  } = props;

  const availableAssetClasses = React.useMemo(() => {
    return getSubSystemConfigItem('onboarding', 'available_asset_classes')
  }, []);

  const hasValidEinzeltitelLicense = React.useMemo(() => {
    const brokerLicense = dataService.user && +dataService.user.bca_level_id;

    let licenseValid = false;

    Object.values(availableAssetClasses).forEach((config) => {
      if (!licenseValid) {
        licenseValid = (config.broker_license || []).includes(brokerLicense)
      }
    })

    return licenseValid
  }, [])

  /**
   * Check, if knowledge and customer's srri is valid for einzeltitel.
   */
  const [hasEinzeltitelKnowledge, hasValidEinzeltitelSrri, einzeltitelMinSrri] = (() => {

    const answers = getRiskProfilingAnswers(dataService, availableAssetClasses);
    if (!answers) {
      // answers are falsy for execution only. As for exec only knowledge and srri are invalid - pass them as true
      return [true, true, undefined]
    }

    let minAcceptableSrri = 8;

    Object.keys(answers).forEach((asset_class) => {
      if (answers[asset_class]) {
        minAcceptableSrri = availableAssetClasses[asset_class].min_srri < minAcceptableSrri
          ? availableAssetClasses[asset_class].min_srri
          : minAcceptableSrri
      }
    });

    const srriValid = skipSrriValidation(dataService.serviceConcept) || dataService._srri >= minAcceptableSrri;

    return [_.some(Object.values(answers), Boolean), srriValid, minAcceptableSrri]

  })();

  const einzeltitelDisabled = !hasEinzeltitelKnowledge || !hasValidEinzeltitelSrri || !hasValidEinzeltitelLicense;

  React.useEffect(() => {
    // init pb question
    let prtBuilderDisableCriteria = [];

    if (dataService.serviceConcept !== SERVICE_CONCEPTS.Anlageberatung) {
      prtBuilderDisableCriteria.push('Muss eine Anlageberatung durchgeführt werden. Anlagevermittlung oder Execution-Only sind nicht möglich.')
    } else if (!dataService.hasInvestmentFundsKnowledge(dataService.serviceConcept)) {
      prtBuilderDisableCriteria.push('Muss der Kunde auf der Seite “Kenntnisse & Erfahrungen” Kenntnisse in “Offene Investmentfonds” vorweisen.')
    }

    portfolioBuilderCheckbox.infoText = <PortfolioBuilderInfoText/>;
    portfolioBuilderCheckbox.disabled = !_.isEmpty(prtBuilderDisableCriteria);
    portfolioBuilderCheckbox.disabledReason = portfolioBuilderCheckbox.disabled && (
      <>
        <div>Um den Portfolio-Builder nutzen zu können:</div>
        {prtBuilderDisableCriteria.map((c, i) => <li key={i}>{c}</li>)}
      </>
    );

    einzeltitelCheckbox.disabled = einzeltitelDisabled;

    if(einzeltitelDisabled){
      if(einzeltitelCheckbox.answer) {
        onAnswerChange(einzeltitelCheckbox.uid, false);
      }

      if(hasValidEinzeltitelLicense) {
        const tooltipEinzeltitelMinSrri = hasEinzeltitelKnowledge ? einzeltitelMinSrri : 3;
        let info = 'Die Bedingungen für den Erwerb von Einzeltiteln sind nicht erfüllt. Diese können sein:  Depotbankauswahl, Wertpapierkenntnisse oder mind.'
        if (!_.isNil(tooltipEinzeltitelMinSrri)) {
          info += ` Risikoklasse ${tooltipEinzeltitelMinSrri} des Kunden.`;
        }

        einzeltitelCheckbox.disabledReason = info;
      }
    }
  }, [einzeltitelDisabled]);

  return (
    <Grid container spacing={2} alignContent={"center"} direction={"column"}>
      <Grid item xs={12} md={6}>
        <CheckboxCardQuestion
          question={fundsCheckbox}
          onAnswerChange={onAnswerChange}
          disabled={fundsCheckbox.disabled || portfolioBuilderCheckbox.answer || vlPlanCheckbox.answer
            || piCheckbox.answer || mpCheckbox.answer || individualAssetManagementCheckbox.answer}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CheckboxCardQuestion
          question={piCheckbox}
          onAnswerChange={onAnswerChange}
          disabled={piCheckbox.disabled || portfolioBuilderCheckbox.answer || fundsCheckbox.answer ||
            vlPlanCheckbox.answer || mpCheckbox.answer || einzeltitelCheckbox.answer || individualAssetManagementCheckbox.answer}
        />
      </Grid>
      {!individualAssetManagementCheckbox._ignore && (
        <Grid item xs={12} md={6}>
          <CheckboxCardQuestion
            question={individualAssetManagementCheckbox}
            onAnswerChange={onAnswerChange}
            disabled={individualAssetManagementCheckbox.disabled || piCheckbox.answer || portfolioBuilderCheckbox.answer
              || fundsCheckbox.answer || vlPlanCheckbox.answer || mpCheckbox.answer || einzeltitelCheckbox.answer}
          />
        </Grid>
      )}
      <Grid item xs={12} md={6}>
        <CheckboxCardQuestion
          question={mpCheckbox}
          onAnswerChange={onAnswerChange}
          disabled={mpCheckbox.disabled || portfolioBuilderCheckbox.answer || fundsCheckbox.answer
            || vlPlanCheckbox.answer || piCheckbox.answer || einzeltitelCheckbox.answer || individualAssetManagementCheckbox.answer}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CheckboxCardQuestion
          question={portfolioBuilderCheckbox}
          onAnswerChange={onAnswerChange}
          disabled={portfolioBuilderCheckbox.disabled || mpCheckbox.answer || fundsCheckbox.answer
            || vlPlanCheckbox.answer || piCheckbox.answer || einzeltitelCheckbox.answer || individualAssetManagementCheckbox.answer}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CheckboxCardQuestion
          question={vlPlanCheckbox}
          onAnswerChange={onAnswerChange}
          disabled={vlPlanCheckbox.disabled || portfolioBuilderCheckbox.answer || fundsCheckbox.answer
            || mpCheckbox.answer || piCheckbox.answer || einzeltitelCheckbox.answer || individualAssetManagementCheckbox.answer}
        />
      </Grid>
      {hasValidEinzeltitelLicense && (
        <Grid item xs={12} md={6}>
          <CheckboxCardQuestion
            question={einzeltitelCheckbox}
            onAnswerChange={onAnswerChange}
            disabled={einzeltitelCheckbox.disabled || portfolioBuilderCheckbox.answer || vlPlanCheckbox.answer
              || mpCheckbox.answer || piCheckbox.answer || individualAssetManagementCheckbox.answer}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default DepositsStepV2;
